<template>
    <div id="progressOfProduction">
        <div class="table_searchbar">
            <el-row :gutter="20">
                <el-col :span="span">
                    <div @keydown.enter="clickSearch">
                        <span class="title">订单号：</span>
                        <el-select style="max-width:180px" filterable="filterable" clearable="clearable"  :loading="loading" :remote-method="remoteMethod" remote="remote" @visible-change='closeOrderList' v-model='searchForm.orderId' size='small' maxlength='16' placeholder='订单号'
                              popper-class='width180'> 
                            <el-option v-for="item in orderOptions" :key="item.id" :value="item.id" :label="item.label"></el-option>
                        </el-select>
                    </div>
                </el-col>

                <el-col :span="span">
                    <div @keydown.enter="clickSearch">
                        <span class="title">物料编码：</span>
                        <el-select clearable :remote-method="query=>this.remoteMethod4(query)" @visible-change='closeProductList' :loading="loading" remote="remote"  
                            filterable="filterable"  style="max-width:180px" v-model="searchForm.materialId" placeholder='物料编码' popper-class='width180'>
                            <el-option v-for="item in materialList" :key="item.id" :value="item.id" :label="item.materialCode"></el-option>
                        </el-select>
                    </div>
                </el-col>

                <el-col :span="span">
                    <div @keydown.enter="clickSearch">
                        <span class="title">物料名称：</span>
                        <el-select clearable :remote-method="query=>this.remoteMethod4('',query)" @visible-change='closeProductList' :loading="loading" remote="remote"  
                            filterable="filterable"  style="max-width:180px" v-model="searchForm.materialId" placeholder='物料名称' popper-class='width180'>
                            <el-option v-for="item in materialList" :key="item.id" :value="item.id" :label="item.materialName"></el-option>
                        </el-select>
                    </div>
                </el-col>

                <el-col :span="span">
                    <div @keydown.enter="clickSearch">
                        <span class="title">规格：</span>
                        <el-select clearable :remote-method="query=>this.remoteMethod4('','',query)" @visible-change='closeProductList' :loading="loading" remote="remote"  
                            filterable="filterable"  style="max-width:180px" v-model="searchForm.materialId" placeholder='规格' popper-class='width180'>
                            <el-option v-for="item in materialList" :key="item.id" :value="item.id" :label="item.specification"></el-option>
                        </el-select>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top:20px;">
                <el-col :span="6">
                    <div @keydown.enter="clickSearch">
                        <span class="title">交付日期：</span>
                        <el-date-picker style="max-width:220px" v-model="searchForm.deliverDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                    </div>
                </el-col>
                <el-col :span="18">
                    <div style="text-align:right">
                        <el-button size="mini" icon="el-icon-search" type="primary" @click="clickSearch()">查询</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-row class="tab">
            <el-table :data="tableData" style="border: 1px solid #868686" :cell-style="cellStyle" :header-cell-style="{ borderColor: '#868686' }" class="table_data" border :maxHeight="W?595:560" :span-method="arraySpanMethod">
                <el-table-column prop="index" label="序号" width="46"></el-table-column>
                <el-table-column prop="orderCode" label="订单号" min-width="100"></el-table-column>
                <el-table-column prop="productionOrderCode" label="订单信息" min-width="120">
                    <template slot-scope="scope">
                        <span>物料名称：{{ scope.row.orderInfo.materialName }}</span><br />
                        <span>物料编码：{{ scope.row.orderInfo.materialCode }}</span><br />
                        <span>物料规格：{{ scope.row.orderInfo.specification }}</span><br />
                        <span>数量：{{ scope.row.orderInfo.itemCount }}{{scope.row.orderInfo.unitOfQuantity}}</span><br />
                        <span>交付时间：{{ scope.row.orderInfo.deliverTime }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="productionBatchCode" label="工单号" :min-width="W?100:90">
                    <template slot-scope="scope">
                        {{scope.row.childProductionBatchCode?scope.row.childProductionBatchCode:scope.row.productionBatchCode}}
                    </template>
                </el-table-column>
                <el-table-column prop="materialName" label="物料名称" :min-width="W?100:90"></el-table-column>
                <el-table-column prop="materialCode" label="物料编码" :min-width="W?100:90"></el-table-column>
                <el-table-column prop="specification" label="规格" :min-width="W?100:90"></el-table-column>
                <el-table-column prop="amount" label="数量" min-width="50"></el-table-column>
                <el-table-column prop="procedureName" label="工序" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="workerName" label="报工人" :min-width="W?90:80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="deviceCode" label="设备" :min-width="W?130:100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="quantityCompleted" label="完成数量" min-width="60"></el-table-column>
                <el-table-column prop="gmtModified" label="最后报工时间" min-width="100" show-overflow-tooltip></el-table-column>
            </el-table>

            <div class="page" v-if="page.isShow">
                <div class="total_page"><span> 共{{page.total}}条 </span></div>
                <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
                    <el-pagination background @size-change="sizeChange" layout=" sizes, prev, pager, next, jumper"
                    :page-count="page.total" :page-sizes="[3,5,10, 20, 30, 50,100]" :page-size.sync="page.pageSize" :total="page.total"
                     @current-change="pageChange" :current-page.sync="page.currentPage"></el-pagination>
                </div>
            </div>
        </el-row>
    </div>
</template>

<script>
let info = { lastIndex: 0, isRed: true };
let info1 = { lastIndex: 0, isRed: true };
export default {
    name: "ProgressOfProduction",
    data() {
        return {
            flag: 0,
            loading:false,
            orderOptions:[],
            tableData: [],
            W:true,
            span: 5,
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            productionOrderCode: null,
            orderCode: null,
            now: new Date(),
            page: {
                isShow: true,
                total: 0,
                currentPage: 1,
                pageSize: 5
            },
            searchFormTemp:{},
            materialList:[],
            searchForm: {
                orderId: null,
                materialId: null,
                deliverDate: []
            }
        };
    },
    mounted: function () {
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        this.init();
        this.loadMaterialList()
        this.orderRemoteMethod()
    },
    methods: {
        init: function () {
            this.search();
        },

        async orderRemoteMethod(query) {
            let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listOrder",params: {orderCode: query}});
            this.orderOptions = data.filter(item => item.label);
        },

        async remoteMethod(query) {
            this.loading = true;
            await this.orderRemoteMethod(query)
            this.loading = false
        },

        async closeOrderList(ev) {
            if (!ev) {
               await this.orderRemoteMethod()
            }
        },

        async closeProductList(ev) {
            if (!ev) {
                await this.loadMaterialList()
            }
        },

        async remoteMethod4(materialCode,materialName,specification) {
            this.loading = true;
            await this.loadMaterialList(materialCode,materialName,specification)
            this.loading = false
        },

        async loadMaterialList(materialCode,materialName,specification){
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: "/api/select/listMaterial",params: {materialCode,materialName,specification}});
            if(code==0){
                this.materialList = data
            }
        },

        parseData(data) {
            let arr = [];
            data.forEach((item, index) => {
                //订单层
                let oLen = 0;
                item.materialDtos.forEach((m, mIndex) => {
                    //订单下多个物料 (一定存在)
                    m.len = m.businessOrderSplitDtos.length;
                    let mlen = 0;
                    m.businessOrderSplitDtos.forEach((b, bIndex) => {
                        if (b.planDetailDtos.length == 0) {
                            mlen++;
                        } else {
                            b.planDetailDtos.forEach((p, pIndex) => {
                                mlen++;
                            });
                        }
                    });
                    oLen += mlen;

                    m.businessOrderSplitDtos.forEach((b, bIndex) => {
                        //物料mrp运算物料  (一定存在)
                        if (b.planDetailDtos.length == 0) {
                            let bLen = null;
                            if (bIndex == 0) {
                                bLen = mlen;
                            }
                            arr.push({
                                orderInfo: {
                                    materialCode: m.materialCode,
                                    materialName: m.materialName,
                                    specification: m.specification,
                                    deliverTime: item.deliverTime,
                                    itemCount: m.itemCount,
                                    unitOfQuantity:m.unitOfQuantity
                                },
                                orderCode: item.orderCode,
                                productionOrderCode: item.productionBatchCode,
                                materialCode: b.splitMaterialCode,
                                materialName: b.splitMaterialName,
                                specification: b.splitSpecification,
                                productionBatchCode: b.productionBatchCode,
                                childProductionBatchCode: b.childProductionBatchCode,
                                amount: b.amount,
                                pLen: 1,
                                mLen: bLen
                            });
                        } else {
                            b.len = b.planDetailDtos.length;
                            b.planDetailDtos.forEach((p, pIndex) => {
                                //物料工艺对应的工序数据  (不一定)
                                let pLen = null;
                                let bLen = null;
                                if (pIndex == 0) {
                                    pLen = b.len;
                                    if (bIndex == 0) {
                                        bLen = mlen;
                                    }
                                }
                                arr.push({
                                    orderInfo: {
                                        materialCode: m.materialCode,
                                        materialName: m.materialName,
                                        specification: m.specification,
                                        deliverTime: item.deliverTime,
                                        itemCount: m.itemCount,
                                        unitOfQuantity:m.unitOfQuantity
                                    },
                                    orderCode: item.orderCode,
                                    productionOrderCode: item.productionBatchCode,
                                    materialCode: b.splitMaterialCode,
                                    materialName: b.splitMaterialName,
                                    specification: b.splitSpecification,
                                    productionBatchCode: b.productionBatchCode,
                                    childProductionBatchCode: b.childProductionBatchCode,
                                    amount: b.amount,
                                    procedureName: p.procedureName,
                                    workerName: p.workerName,
                                    deviceCode: p.deviceCode,
                                    deviceName: p.deviceName,
                                    gmtModified: p.gmtModified,
                                    quantityCompleted: p.quantityCompleted,
                                    pLen,
                                    mLen: bLen
                                });
                            });
                        }
                    });
                });
                arr[arr.length - oLen].oLen = oLen;
                arr[arr.length - oLen].index = index + 1;
            });
            return arr;
        },

        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex > 7) {
                return [1, 1];
            }

            if (columnIndex >= 3 && columnIndex <= 7) {
                if (row.pLen) {
                    return [row.pLen, 1];
                } else {
                    return [0, 0];
                }
            }
            if (columnIndex == 2) {
                if (row.mLen) {
                    return [row.mLen, 1];
                } else {
                    return [0, 0];
                }
            }
            if (columnIndex == 1 || columnIndex == 0) {
                if (row.oLen) {
                    return [row.oLen, 1];
                } else {
                    return [0, 0];
                }
            }
        },

        cellStyle({ row, column, rowIndex, columnIndex }) {
            let json = { borderColor: "#868686" };
            if (columnIndex >= 3 && columnIndex <= 7) {
                if (info.lastIndex != rowIndex) {
                    info.lastIndex = rowIndex;
                    info.isRed = !info.isRed;
                }
                if (info.isRed) {
                    json.background = "#F5F7FA";
                    json.color = "#333";
                }
                json.fontSize = "14px";
            }
            if (columnIndex > 7) {
                if (columnIndex == 8) {
                    if (rowIndex == 0) {
                        info1.lastIndex = row.pLen;
                    }
                    if (info1.lastIndex == 0) {
                        info1.lastIndex = row.pLen;
                        info1.isRed = !info1.isRed;
                    }
                    info1.lastIndex--;
                }
                if (info1.isRed) {
                    json.background = "#F5F7FA";
                    json.color = "#333";
                }
            }
            if (columnIndex == 1) {
                json.fontSize = "16px";
            }
            return json;
        },

        clickSearch: function () {
            this.btnPressType = 1
            this.search(1);
        },

        pageChange(pageNum) {
            this.btnPressType = 3;
            this.search(pageNum);
        },

        //清空查询条件
        clearSearch() { 
            this.btnPressType = 2
            
            this.searchForm = {
                materialId:null,
                orderId:null,
                deliverDate:[],
            }
        },

        sizeChange(ev) {
            this.$set(this.page, 'pageSize', ev)
            this.search();
        },

        search: function (pageNum) {
            if (pageNum == null || pageNum instanceof KeyboardEvent) {
                pageNum = 1;
            }
            this.page.currentPage = pageNum
            let temp;
            switch (this.btnPressType) {
              case 1:
                temp = commonUtils.cloneObj(this.searchForm);
                this.searchFormTemp = commonUtils.cloneObj(temp);
                break;
              case 0:
                temp ={
                  deliverDate:[],
                  materialId: null,
                  materialId: null
                };
                break;
              case 2:
                temp = this.searchFormTemp;
                break;
              case 3:
                temp = this.searchFormTemp;
                break;
            }
            this.pageNum = pageNum;
            let deliverStartDate,deliverEndDate;
            if(temp.deliverDate&&temp.deliverDate.length==2){
                deliverStartDate = temp.deliverDate[0]
                deliverEndDate = temp.deliverDate[1]
            }
            this.$RequestUtil.get({
                url: "/api/productionSchedule/list",
                type: "sync",
                params: {
                    deliverStartDate,
                    deliverEndDate,
                    materialId: temp.materialId,
                    orderId: temp.orderId,
                    pageNum: pageNum,
                    pageSize: this.page.pageSize
                },
                success: res => {
                    if (res.code == 0) {
                        this.tableData = this.parseData(res.data);
                        this.page.total = res.totalPages;
                        if (res.totalPages == 0) {
                            this.$message.warning("查询不到符合条件的数据");
                        }
                    } else {
                        this.$message.error(res.message || res.msg);
                    }
                }
            });
        }
    }
};
</script>
<style>
    #progressOfProduction .el-table tr {
        height: 30px !important;
    }
    #progressOfProduction .el-table tbody tr:hover > td {
        background-color: #fff;
    }
    .width180 {
        width: 180px;
    }
</style>

<style scoped>
    .table_searchbar {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 20px;
    }
    .table_searchbar .title11 {
        color: #606266;
        font-family: NotoSansHans-Regula;
        font-size: 14px;
    }
    ::-webkit-scrollbar {
        width: 0px;
        height: 0px;
        background-color: #f0f0f0;
    }
    .search-input-row {
        margin-top: 10px;
    }
    .page {
        display: flex;
        justify-content: flex-end;
    }
    .total_page {
        margin-top: 15px;
        margin-right: 26px;
        color: #606266;
        font-size: 14px;
    }

    @media screen and (max-width: 1380px) {
        .page {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 30px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/order/SalesOrder/ProgressOfProduction.vue